/* eslint-disable react/no-danger */
import PropTypes from 'prop-types'
import { Trans } from 'react-i18next'
import { Caption } from '../typography/Caption'
import * as styles from './CalculatorModule.module.scss'

const CalculatorModule = ({ calculator }) => {
  return (
    <div data-qa="calculator-module-container">
      <div className={styles.Card}>
        {calculator}
        <Caption className={styles.Disclaimer}>
          <Trans i18nKey="CalculatorModule.disclaimer">
            This information may help you analyze your financial needs. It is based on information
            and assumptions provided by you regarding your goals, expectations and financial
            situation. The calculations do not infer that the company assumes any fiduciary duties.
            The calculations provided should not be construed as financial, legal or tax advice. In
            addition, such information should not be relied upon as the only source of information.
            This information is supplied from sources we believe to be reliable but we cannot
            guarantee its accuracy. Hypothetical illustrations may provide historical or current
            performance information. Past performance does not guarantee nor indicate future
            results.
          </Trans>
        </Caption>
      </div>
    </div>
  )
}

CalculatorModule.propTypes = {
  calculator: PropTypes.element.isRequired,
}

export { CalculatorModule }
export default CalculatorModule
